import { Injectable } from '@angular/core';
import { Modal } from './modal';
import { Subject } from 'rxjs';

export class ModalCallback {
	constructor(confirm: any, cancel: any) {
		this.confirm = confirm;
		this.cancel = cancel;
	}
	confirm: any;
	cancel: any;
}

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	modals: Subject<Modal>;
	isShowingFlags: Subject<boolean>;
	callback: ModalCallback;

	constructor() {
		this.modals = new Subject<Modal>();
		this.isShowingFlags = new Subject<boolean>();
	}

	open(modal: Modal, callback: ModalCallback) {
		this.modals.next(modal);
		this.isShowingFlags.next(true);
		this.callback = callback;
	}

	closeConfirm() {
		this.isShowingFlags.next(false);
		this.callback.confirm(true);
	}

	closeCancel() {
		this.isShowingFlags.next(false);
		this.callback.cancel(false);
	}
}
